export default __webpack_public_path__ + "static/media/rarity-sniper.167a4cd9.167a4cd9.png";